var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],class:'parent ' + _vm.size},[_c('div',{staticClass:"loading"},[_c('div',{class:'spinner ' + _vm.type})])])
}
var staticRenderFns = []

export { render, staticRenderFns }